import {
  BrandingMain_CoverImage,
} from "../../../assets/data/Imagedata";

import {
  DefaultIcon,
} from "../../../assets/data/icon_data";


export const BrandIdentityDesignExclusivePageDetails = {
  SeoName: {
    seotitle: "BrandIdentityDesignExclusivePageDetailsseo",
  },
  section2: {
    tagline: "Define Your Corporate Identity",
    heading: "Branding & Corporate Identity Design Services",
    description:
      "Exclusive brand identity solutions that set your business apart. From logo creation to comprehensive brand kits and guidelines, we ensure your brand speaks with clarity, consistency, and professional impact.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Logo Design",
      description: "Creative and memorable logos that define your brand.",
      details: [
        "Multiple design concepts",
        "Vector source files",
        "Brand-aligned aesthetics",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Brand Identity Development",
      description: "Comprehensive visual language for your business.",
      details: [
        "Color palette selection",
        "Typography standards",
        "Visual style guide",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Visiting Cards",
      description: "Professional and impactful business card designs.",
      details: ["Unique layouts", "Print-ready formats", "Premium aesthetics"],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Brochures",
      description: "Informative and engaging brochures for your products.",
      details: [
        "Bi-fold & Tri-fold options",
        "Custom layout & graphics",
        "Product-focused design",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "ID Cards",
      description: "Standardized and secure ID card designs for your team.",
      details: [
        "Clean and professional layouts",
        "Custom fields and branding",
        "Print-ready quality",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Letterheads",
      description: "Branded stationery for professional correspondence.",
      details: [
        "Minimalist & modern designs",
        "Digital & print-ready formats",
        "Consistent brand messaging",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Banners & Flex Designs",
      description: "Large-scale branding for events and physical locations.",
      details: [
        "High-resolution graphics",
        "Custom sizing & layouts",
        "Outdoor & indoor options",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Complete Brand Kits",
      description: "All-in-one branding package for your startup/business.",
      details: [
        "Logo + Stationery + Guidelines",
        "Social media assets",
        "Ready-to-use templates",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Brand Guidelines Kit",
      description: "Detailed manuals to maintain brand consistency.",
      details: [
        "Logo usage rules",
        "Color & Font specifications",
        "Voice & Tone guidelines",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Brand Identity Package",
      price: "",
      features: [
        "Logo design concepts",
        "Color palette and typography",
        "Basic brand collateral",
        "Delivery in 15 days",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Comprehensive Brand Identity",
      price: "",
      features: [
        "All Basic Package features",
        "Custom iconography & graphics",
        "Brand guidelines document",
        "Priority revisions",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Premium Brand Identity Suite",
      price: "",
      features: [
        "Full service branding consultation",
        "Complete collateral suite design",
        "Brand strategy workshop",
        "Extended support and updates",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: BrandingMain_CoverImage,
  title: "Exclusive Brand Identity Design",
  subtitle:
    "Elevate your brand with custom-crafted visual identities that resonate, inspire, and create lasting impressions.",
  coverImage: {
    src: BrandingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "What is included in your brand identity design service?",
      answer:
        "We provide logo design, color palettes, typography, iconography, brand collateral, and comprehensive brand guidelines.",
    },
    {
      question: "How long does the design process take?",
      answer:
        "Typical projects take between 2 to 4 weeks depending on package and complexity.",
    },
    {
      question: "Can you create brand guidelines for existing logos?",
      answer:
        "Yes, we offer standalone brand guideline creation to maintain consistency across your brand assets.",
    },
    {
      question: "Do you provide revisions during the design process?",
      answer:
        "Absolutely. We include multiple revision rounds to ensure your brand identity perfectly aligns with your vision.",
    },
    {
      question: "Will I receive the original design files?",
      answer:
        "Yes, all packages include source files and all formats needed for print and digital use.",
    },
  ],
};

export const BrandLogoDesignPageDetails = {
  SeoName: {
    seotitle: "BrandLogoDesignPageDetailsseo",
  },
  section2: {
    tagline: "Create a Memorable Brand Mark",
    heading: "Professional Brand Logo Design Services",
    description:
      "Cyber Space Digital specializes in crafting unique and impactful logos that represent your brands identity and values. Our logo designs help you stand out and build instant recognition across all platforms.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Custom Logo Concepts",
      description:
        "Original logo designs tailored to your brands story and target audience.",
      details: [
        "Multiple initial concepts to choose from.",
        "Refinements based on your feedback.",
        "Versatile designs for all uses.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Logo Variations",
      description:
        "Deliver logos optimized for different backgrounds and formats.",
      details: [
        "Full color, black & white, and single color versions.",
        "Horizontal, vertical, and icon-only variants.",
        "Formats suitable for print, web, and social media.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Vector & Source Files",
      description:
        "High-quality source files that allow scalability and easy editing.",
      details: [
        "AI, EPS, SVG formats.",
        "PNG and JPEG for immediate use.",
        "Font and color specifications included.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Brand Consultation",
      description: "Expert advice on logo usage and brand consistency.",
      details: [
        "Guidance on color application and placement.",
        "Recommendations for integrating logo with brand identity.",
        "Support for marketing and advertising needs.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Logo Package",
      price: "",
      features: [
        "3 initial logo concepts",
        "2 rounds of revisions",
        "Delivery in 7 days",
        "PNG and JPEG files",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Standard Logo Package",
      price: "",
      features: [
        "5 initial concepts",
        "Unlimited revisions",
        "Vector files included",
        "Brand consultation",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Premium Logo Suite",
      price: "",
      features: [
        "Complete logo system (primary + secondary logos)",
        "Logo usage guidelines",
        "Extended support & brand collateral templates",
        "Priority delivery in 5 days",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: BrandingMain_CoverImage,
  title: "Brand Logo Design Services",
  subtitle:
    "Get a professionally designed logo that captures your brand essence and makes a lasting impression across all touchpoints.",
  coverImage: {
    src: BrandingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "How many logo concepts will I receive?",
      answer:
        "Depending on the package, you will get between 3 to 5 initial logo concepts to choose from.",
    },
    {
      question: "Can I request revisions to the logo?",
      answer:
        "Yes, we include multiple revision rounds to ensure the final logo meets your expectations.",
    },
    {
      question: "Will I get source files of the logo?",
      answer:
        "Absolutely. All packages include high-resolution vector source files for unlimited usage.",
    },
    {
      question: "How long does the logo design process take?",
      answer:
        "Typically, the process takes between 1 to 2 weeks depending on the package and feedback rounds.",
    },
    {
      question: "Can you help with logo usage guidelines?",
      answer:
        "Yes, premium packages include logo usage guidelines to maintain consistency across all brand materials.",
    },
  ],
};

export const BrandGuidelinesPageDetails = {
  SeoName: {
    seotitle: "BrandGuidelinesPageDetailsseo",
  },
  section2: {
    tagline: "Maintain Brand Consistency",
    heading: "Comprehensive Brand Guidelines Development",
    description:
      "Cyber Space Digital helps you create detailed brand guideline documents that ensure your brand identity remains consistent across all channels and touchpoints.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Logo Usage Rules",
      description:
        "Clear instructions on how to use your logo correctly in various contexts.",
      details: [
        "Proper logo spacing and sizing.",
        "Dos and donts for logo application.",
        "Color variations and background usage.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Color Palette",
      description:
        "Define your brands official color scheme for print and digital media.",
      details: [
        "Primary and secondary colors.",
        "Color codes (RGB, CMYK, HEX, Pantone).",
        "Usage guidelines for consistent application.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Typography",
      description:
        "Standardize fonts and text styles for all brand communications.",
      details: [
        "Primary and secondary typefaces.",
        "Font sizes, weights, and styles.",
        "Usage in headings, body text, and captions.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Visual Elements & Imagery",
      description:
        "Guidelines on icons, photography style, and graphic elements.",
      details: [
        "Icon style and usage.",
        "Photography guidelines and tone.",
        "Graphic elements and patterns.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Brand Voice & Messaging",
      description:
        "Define the tone, language, and messaging style for consistent communication.",
      details: [
        "Voice characteristics and tone.",
        "Key messaging pillars.",
        "Examples of approved copy style.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Brand Guidelines",
      price: "",
      features: [
        "Logo usage rules",
        "Primary color palette",
        "Typography standards",
        "Delivery in 7 days",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Standard Brand Guidelines",
      price: "",
      features: [
        "Includes basic package features",
        "Extended color palette",
        "Visual elements & imagery",
        "Brand voice guidelines",
        "Delivery in 10 days",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Comprehensive Brand Book",
      price: "",
      features: [
        "Full guideline document",
        "Detailed messaging & tone",
        "Templates for brand assets",
        "Ongoing brand consulting",
        "Priority delivery in 7 days",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: BrandingMain_CoverImage,
  title: "Brand Guidelines Services",
  subtitle:
    "Ensure consistent brand presentation with professionally crafted brand guidelines that cover every aspect of your brand identity.",
  coverImage: {
    src: BrandingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "What are brand guidelines?",
      answer:
        "Brand guidelines are a set of rules and standards that dictate how your brand is presented visually and verbally to ensure consistency.",
    },
    {
      question: "Why do I need brand guidelines?",
      answer:
        "They help maintain a consistent brand image across all marketing channels and prevent misuse of your brand assets.",
    },
    {
      question: "Can brand guidelines be updated?",
      answer:
        "Yes, guidelines should evolve with your brand. We offer ongoing consulting for updates and refinements.",
    },
    {
      question: "Do you provide digital and print versions?",
      answer:
        "Absolutely. We deliver guidelines in both digital (PDF) and print-ready formats.",
    },
    {
      question: "How long does it take to create brand guidelines?",
      answer:
        "Depending on the package, it typically takes 1 to 2 weeks to develop comprehensive brand guidelines.",
    },
  ],
};

export const BrandPositioningPageDetails = {
  SeoName: {
    seotitle: "BrandPositioningPageDetailsseo",
  },
  section2: {
    tagline: "Define Your Market Edge",
    heading: "Strategic Brand Positioning Services",
    description:
      "Cyber Space Digital helps you carve a unique space in the market by defining your brands value proposition, target audience, and competitive differentiation.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Market Research & Analysis",
      description:
        "Understand your industry, competitors, and audience to identify opportunities.",
      details: [
        "Competitive landscape assessment.",
        "Customer behavior and preferences study.",
        "Trend identification and forecasting.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Value Proposition Development",
      description:
        "Craft a compelling brand promise that resonates with your target customers.",
      details: [
        "Unique selling points identification.",
        "Clear and concise messaging.",
        "Benefit-focused positioning statements.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Target Audience Segmentation",
      description:
        "Define and segment your ideal customers for tailored marketing strategies.",
      details: [
        "Demographic, psychographic profiling.",
        "Behavioral and needs-based segmentation.",
        "Persona creation for marketing alignment.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Brand Differentiation Strategy",
      description:
        "Develop tactics to stand out from competitors and build brand loyalty.",
      details: [
        "Competitive advantage identification.",
        "Brand personality and tone definition.",
        "Messaging frameworks and positioning maps.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Positioning Statement Creation",
      description:
        "Deliver clear, memorable, and actionable brand positioning statements for internal and external use.",
      details: [
        "Crafting unique positioning statements.",
        "Aligning statements with brand strategy.",
        "Training and implementation support.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Positioning Plan",
      price: "",
      features: [
        "Market research summary",
        "Basic positioning statement",
        "Target audience overview",
        "Delivery in 7 days",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Advanced Positioning Plan",
      price: "",
      features: [
        "Detailed research & analysis",
        "Comprehensive positioning strategy",
        "Audience segmentation & personas",
        "Messaging framework",
        "Delivery in 12 days",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Premium Positioning Package",
      price: "",
      features: [
        "Full positioning strategy & roadmap",
        "Implementation workshops",
        "Ongoing consulting support",
        "Competitive monitoring",
        "Priority delivery in 10 days",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: BrandingMain_CoverImage,
  title: "Brand Positioning Services",
  subtitle:
    "Position your brand for success with strategic insights and messaging that captivate your ideal customers and differentiate you from competitors.",
  coverImage: {
    src: BrandingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "What is brand positioning?",
      answer:
        "Brand positioning is the process of defining how your brand is perceived in the minds of your target customers compared to competitors.",
    },
    {
      question: "Why is brand positioning important?",
      answer:
        "It helps create a clear, distinctive image and message that attracts and retains your ideal customers.",
    },
    {
      question: "How long does brand positioning take?",
      answer:
        "Typically, it takes 1 to 3 weeks depending on research depth and strategy complexity.",
    },
    {
      question: "Can you help implement the positioning strategy?",
      answer:
        "Yes, we offer workshops, training, and consulting to ensure successful implementation.",
    },
    {
      question: "Do you provide ongoing support after positioning?",
      answer:
        "Absolutely. We provide monitoring and refinement services to keep your brand relevant and competitive.",
    },
  ],
};

export const BrandStorytellingPageDetails = {
  SeoName: {
    seotitle: "BrandStorytellingPageDetailsseo",
  },
  section2: {
    tagline: "Craft Stories That Connect",
    heading: "Compelling Brand Storytelling Services",
    description:
      "At Cyber Space Digital, we help you build authentic narratives that emotionally engage your audience and strengthen your brand identity across all channels.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Narrative Development",
      description:
        "Create a unique brand story that reflects your values, mission, and vision.",
      details: [
        "Identify core brand message and themes.",
        "Develop emotional and relatable story arcs.",
        "Align storytelling with business goals.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Content Creation",
      description:
        "Produce engaging content for websites, social media, videos, and marketing campaigns.",
      details: [
        "Blog posts and articles.",
        "Video scripts and storyboards.",
        "Social media storytelling posts.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Visual Storytelling",
      description:
        "Use design, imagery, and video to bring your brand story to life visually.",
      details: [
        "Brand videos and animations.",
        "Infographics and illustrations.",
        "Photography and imagery direction.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Customer Storytelling",
      description:
        "Highlight authentic customer experiences and testimonials to build trust.",
      details: [
        "Case studies and success stories.",
        "User-generated content campaigns.",
        "Social proof and reviews integration.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Storytelling Workshops",
      description:
        "Train your team on effective brand storytelling techniques and content creation.",
      details: [
        "Storytelling frameworks and methods.",
        "Content strategy alignment.",
        "Hands-on storytelling exercises.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Storytelling Package",
      price: "",
      features: [
        "Core brand narrative development",
        "One content piece (blog or social post)",
        "Delivery in 7 days",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Standard Storytelling Package",
      price: "",
      features: [
        "Comprehensive brand story",
        "Multiple content formats (blogs, videos)",
        "Visual storytelling assets",
        "Delivery in 14 days",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Premium Storytelling Suite",
      price: "",
      features: [
        "Full brand storytelling strategy",
        "Content calendar & creation",
        "Storytelling workshops",
        "Customer storytelling campaigns",
        "Priority delivery in 10 days",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: BrandingMain_CoverImage,
  title: "Brand Storytelling Services",
  subtitle:
    "Engage your audience with powerful stories that build emotional connections and elevate your brand presence.",
  coverImage: {
    src: BrandingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "Why is brand storytelling important?",
      answer:
        "It helps create emotional connections with your audience, making your brand memorable and trustworthy.",
    },
    {
      question: "What types of content do you create?",
      answer:
        "We produce blogs, videos, social media posts, infographics, customer stories, and more.",
    },
    {
      question: "Can you help train my team on storytelling?",
      answer:
        "Yes, we offer workshops and hands-on sessions to improve your team's storytelling skills.",
    },
    {
      question: "How long does it take to develop a brand story?",
      answer:
        "Typically, 1 to 3 weeks depending on the depth and complexity of your brand narrative.",
    },
    {
      question: "Do you assist with ongoing content creation?",
      answer:
        "Absolutely. We provide content calendars and ongoing support to keep your brand story fresh and engaging.",
    },
  ],
};

export const BrandNamingPageDetails = {
  SeoName: {
    seotitle: "BrandNamingPageDetailsseo",
  },
  section2: {
    tagline: "Create a Name That Resonates",
    heading: "Professional Brand Naming Services",
    description:
      "Cyber Space Digital crafts memorable, meaningful, and market-ready brand names that capture your essence and appeal to your target audience.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Name Ideation & Brainstorming",
      description:
        "Collaborative sessions to generate creative and unique brand name options.",
      details: [
        "Market research and competitor analysis.",
        "Exploration of naming trends and styles.",
        "Brainstorming sessions with your team.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Linguistic & Cultural Checks",
      description:
        "Ensure your brand name is appropriate and effective across different languages and cultures.",
      details: [
        "Avoid negative or inappropriate meanings.",
        "Check for pronunciation and memorability.",
        "Verify cultural sensitivity and relevance.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Trademark & Domain Availability",
      description:
        "Verify legal availability and secure your brand name online.",
      details: [
        "Preliminary trademark clearance checks.",
        "Domain name availability search.",
        "Recommendations for alternative options.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Name Testing & Validation",
      description:
        "Gather feedback and validate potential names with your target audience.",
      details: [
        "Surveys and focus groups.",
        "Online polls and social listening.",
        "Data-driven name selection.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Naming Strategy & Brand Architecture",
      description:
        "Develop a coherent naming strategy aligned with your brand vision and portfolio.",
      details: [
        "Product and service naming.",
        "Sub-brand and extension strategies.",
        "Consistent naming conventions.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Naming Package",
      price: "",
      features: [
        "5 Name Suggestions",
        "Basic Linguistic Checks",
        "Domain Availability Report",
        "Delivery in 7 Days",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Standard Naming Package",
      price: "",
      features: [
        "15 Name Suggestions",
        "Trademark Pre-checks",
        "Audience Testing",
        "Delivery in 14 Days",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Premium Naming Suite",
      price: "",
      features: [
        "30+ Name Suggestions",
        "Comprehensive Trademark & Domain Checks",
        "Extensive Audience Validation",
        "Naming Strategy Development",
        "Priority Delivery in 10 Days",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: BrandingMain_CoverImage,
  title: "Brand Naming Services",
  subtitle:
    "Find the perfect name that defines your brands identity and sets you apart in the marketplace.",
  coverImage: {
    src: BrandingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "Why is a good brand name important?",
      answer:
        "A strong brand name enhances recall, builds trust, and communicates your brands personality effectively.",
    },
    {
      question: "Do you check if my chosen name is legally available?",
      answer:
        "We conduct preliminary trademark checks to help avoid legal conflicts and recommend further legal consultation.",
    },
    {
      question: "Can you help with domain name registration?",
      answer:
        "We verify domain availability and suggest suitable alternatives, but registration is done through domain providers.",
    },
    {
      question: "How long does the naming process take?",
      answer:
        "Typically 1 to 3 weeks depending on project scope and feedback cycles.",
    },
    {
      question: "Can I get multiple name options?",
      answer:
        "Yes, our packages provide multiple name suggestions tailored to your brands needs.",
    },
  ],
};

export const VisualIdentityDesignPageDetails = {
  SeoName: {
    seotitle: "VisualIdentityDesignPageDetailsseo",
  },
  section2: {
    tagline: "Build a Cohesive Visual Presence",
    heading: "Comprehensive Visual Identity Design Services",
    description:
      "Cyber Space Digital crafts striking visual identities that embody your brands core values and create lasting impressions across all customer touchpoints.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Logo Design & Variations",
      description:
        "Create a versatile logo system that works across platforms and mediums.",
      details: [
        "Primary and secondary logo versions.",
        "Black & white and color variations.",
        "Scalable vector files for print and digital.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Color Palette & Typography",
      description:
        "Define your brands color scheme and typography guidelines for consistency.",
      details: [
        "Primary, secondary, and accent colors.",
        "Font pairings and usage rules.",
        "Accessible and brand-aligned styles.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Iconography & Graphic Elements",
      description:
        "Develop unique icons and graphic components that support your brand story.",
      details: [
        "Custom icons tailored to your brand.",
        "Patterns, textures, and graphic motifs.",
        "Usage guidelines for digital and print.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Brand Collateral Design",
      description:
        "Design essential brand materials such as business cards, letterheads, and presentation templates.",
      details: [
        "Consistent application of visual identity.",
        "Printable and digital-ready formats.",
        "Templates for internal and external use.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Brand Style Guide",
      description:
        "Create a comprehensive manual documenting all visual identity elements and their proper usage.",
      details: [
        "Logo usage rules and restrictions.",
        "Color and typography standards.",
        "Examples and dos & donts.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Visual Identity Package",
      price: "",
      features: [
        "Logo Design",
        "Primary Color Palette",
        "Typography Selection",
        "Delivery in 10 Days",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Standard Visual Identity Package",
      price: "",
      features: [
        "Logo Variations & Iconography",
        "Extended Color Palette",
        "Brand Collateral Templates",
        "Delivery in 15 Days",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Premium Visual Identity Suite",
      price: "",
      features: [
        "Complete Visual Identity System",
        "Comprehensive Brand Style Guide",
        "Custom Graphic Elements",
        "Priority Support & Delivery in 12 Days",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: BrandingMain_CoverImage,
  title: "Visual Identity Design Services",
  subtitle:
    "Establish a consistent and compelling visual language that strengthens your brand and engages your audience.",
  coverImage: {
    src: BrandingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "What is included in a visual identity design?",
      answer:
        "It includes logos, color palettes, typography, icons, and brand collateral designs to create a unified look.",
    },
    {
      question: "Why is a brand style guide important?",
      answer:
        "It ensures consistent use of visual elements across all channels, helping maintain brand integrity.",
    },
    {
      question: "Can you update an existing visual identity?",
      answer:
        "Yes, we can refresh or redesign your current visual assets to better align with your brand goals.",
    },
    {
      question: "How long does the process take?",
      answer:
        "Typically 2 to 4 weeks depending on complexity and client feedback.",
    },
    {
      question: "Do you provide digital and print-ready files?",
      answer:
        "Absolutely, all final deliverables include high-resolution files for both digital and print use.",
    },
  ],
};

export const BrandMessagingPageDetails = {
  SeoName: {
    seotitle: "BrandMessagingPageDetailsseo",
  },
  section2: {
    tagline: "Craft Your Brands Voice and Message",
    heading: "Strategic Brand Messaging Development",
    description:
      "Cyber Space Digital helps you develop clear, consistent, and compelling messaging that resonates with your target audience and reinforces your brand identity.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Core Message & Value Proposition",
      description:
        "Define what makes your brand unique and why customers should choose you.",
      details: [
        "Clear articulation of your brands purpose and values.",
        "Compelling value propositions tailored to your audience.",
        "Message hierarchy to prioritize key points.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Tagline & Slogan Creation",
      description:
        "Develop memorable and impactful taglines that capture your brand essence.",
      details: [
        "Short, catchy, and brand-aligned phrases.",
        "Multiple options to choose from.",
        "Refinement based on your feedback.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Tone of Voice & Communication Style",
      description:
        "Establish a consistent tone and style for all brand communications.",
      details: [
        "Formal, casual, playful, authoritative, or friendly tones.",
        "Guidelines for written and verbal communication.",
        "Adaptation for different channels and audiences.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Audience Segmentation & Messaging",
      description:
        "Tailor messages for different customer segments to increase relevance and engagement.",
      details: [
        "Identify key audience groups.",
        "Develop targeted messages for each segment.",
        "Create messaging frameworks for campaigns.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Messaging Guidelines & Documentation",
      description:
        "Provide a comprehensive guide to ensure consistent messaging across teams and channels.",
      details: [
        "Dos and donts for brand language.",
        "Sample messaging templates.",
        "Training materials for internal teams.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Messaging Package",
      price: "",
      features: [
        "Core Message Definition",
        "Tagline Creation",
        "Basic Tone of Voice",
        "Delivery in 7 Days",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Standard Messaging Package",
      price: "",
      features: [
        "Audience Segmentation",
        "Multiple Tagline Options",
        "Detailed Tone of Voice Guidelines",
        "Delivery in 10 Days",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Premium Messaging Suite",
      price: "",
      features: [
        "Comprehensive Messaging Framework",
        "Messaging Guidelines Document",
        "Internal Training Support",
        "Priority Delivery in 7 Days",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: BrandingMain_CoverImage,
  title: "Brand Messaging Services",
  subtitle:
    "Communicate your brands unique story and values effectively with consistent and strategic messaging.",
  coverImage: {
    src: BrandingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "Why is brand messaging important?",
      answer:
        "It helps create a clear and consistent narrative that connects with your audience and differentiates your brand.",
    },
    {
      question: "Can messaging evolve over time?",
      answer:
        "Yes, messaging should adapt to market trends, customer feedback, and brand growth while maintaining core consistency.",
    },
    {
      question: "Do you help with messaging for all channels?",
      answer:
        "Absolutely, we tailor messaging guidelines for websites, social media, advertising, and internal communications.",
    },
    {
      question: "How involved will I be in the process?",
      answer:
        "We collaborate closely with you for feedback and approvals to ensure messaging aligns perfectly with your vision.",
    },
    {
      question: "Can you help with crisis communication messaging?",
      answer:
        "Yes, we provide strategic messaging support for managing communications during challenging situations.",
    },
  ],
};

export const BrandExperienceDesignPageDetails = {
  SeoName: {
    seotitle: "BrandExperienceDesignPageDetailsseo",
  },
  section2: {
    tagline: "Design Meaningful Interactions",
    heading: "Create Exceptional Brand Experiences Across Touchpoints",
    description:
      "Cyber Space Digital crafts seamless and memorable brand experiences that engage customers emotionally and foster loyalty at every interaction.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Customer Journey Mapping",
      description:
        "Analyze and design customer journeys to deliver consistent and impactful experiences.",
      details: [
        "Identify key touchpoints and pain points.",
        "Create optimized journey flows.",
        "Personalize experiences based on behavior and preferences.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Omnichannel Experience Design",
      description:
        "Deliver a unified brand experience across digital, physical, and social channels.",
      details: [
        "Integrate online and offline touchpoints.",
        "Ensure consistent messaging and visuals.",
        "Enhance customer engagement and satisfaction.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Service Design & Innovation",
      description:
        "Design and improve services that align with brand values and customer expectations.",
      details: [
        "Develop service blueprints and workflows.",
        "Identify opportunities for innovation.",
        "Enhance usability and convenience.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Brand Touchpoint Optimization",
      description:
        "Optimize every interaction point to maximize positive brand perception.",
      details: [
        "Evaluate current touchpoints for effectiveness.",
        "Implement enhancements based on data and feedback.",
        "Train staff to deliver brand-aligned experiences.",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Experience Metrics & Analytics",
      description:
        "Measure and analyze brand experience performance to drive continuous improvement.",
      details: [
        "Track customer satisfaction and loyalty metrics.",
        "Analyze feedback and behavior patterns.",
        "Adjust strategies based on insights.",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Experience Design",
      price: "",
      features: [
        "Customer Journey Mapping",
        "Touchpoint Analysis",
        "Experience Improvement Plan",
        "Delivery in 7 Days",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Comprehensive Experience Design",
      price: "",
      features: [
        "Omnichannel Strategy",
        "Service Design Blueprint",
        "Touchpoint Optimization",
        "Delivery in 14 Days",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Premium Experience Suite",
      price: "",
      features: [
        "Full Experience Strategy & Execution",
        "Analytics & Reporting",
        "Staff Training & Support",
        "Priority Delivery in 10 Days",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: BrandingMain_CoverImage,
  title: "Brand Experience Design Services",
  subtitle:
    "Elevate your brand by designing meaningful, consistent, and memorable experiences for your customers.",
  coverImage: {
    src: BrandingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "What is brand experience design?",
      answer:
        "Its the process of designing interactions and touchpoints that shape how customers perceive and feel about your brand.",
    },
    {
      question: "Why is an omnichannel experience important?",
      answer:
        "Customers engage with brands across multiple channels; a unified experience ensures consistency and stronger brand loyalty.",
    },
    {
      question: "How do you measure brand experience success?",
      answer:
        "Through metrics like customer satisfaction, Net Promoter Score, repeat purchases, and qualitative feedback.",
    },
    {
      question:
        "Can you help with both digital and physical brand experiences?",
      answer:
        "Yes, we design seamless experiences across websites, apps, stores, events, and more.",
    },
    {
      question: "What industries do you serve?",
      answer:
        "We work with diverse sectors including retail, hospitality, technology, healthcare, and more.",
    },
  ],
};

export const BrandAwarenessCampaignsPageDetails = {
  SeoName: {
    seotitle: "BrandAwarenessCampaignsPageDetailsseo",
  },
  section2: {
    tagline: "Boost Your Brand Visibility",
    heading: "Strategic Brand Awareness Campaigns That Connect and Convert",
    description:
      "Cyber Space Digital creates powerful brand awareness campaigns designed to increase recognition, build trust, and drive customer engagement across multiple channels.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Target Audience Research",
      description:
        "Identify and understand your ideal customers to tailor campaigns that resonate.",
      details: [
        "Demographic and psychographic profiling",
        "Competitive landscape analysis",
        "Behavioral insights and preferences",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Multi-Channel Campaign Strategy",
      description:
        "Design integrated campaigns across social media, digital ads, PR, and offline channels.",
      details: [
        "Social media marketing and influencer partnerships",
        "Paid digital advertising (PPC, display ads)",
        "Event sponsorships and experiential marketing",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Creative Campaign Development",
      description:
        "Craft compelling visuals, messaging, and content that capture attention and communicate your brand story.",
      details: [
        "Concept ideation and storyboard creation",
        "Video production and graphic design",
        "Copywriting tailored to target audiences",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Campaign Execution & Management",
      description:
        "Implement and monitor campaigns to ensure maximum reach and impact.",
      details: [
        "Media buying and placement optimization",
        "Real-time performance tracking",
        "Budget management and ROI analysis",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Reporting & Insights",
      description:
        "Analyze campaign results to refine strategies and improve future brand awareness efforts.",
      details: [
        "Detailed analytics and reporting dashboards",
        "Customer sentiment analysis",
        "Recommendations for continuous improvement",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Awareness Package",
      price: "",
      features: [
        "Audience Research",
        "Social Media Campaign Setup",
        "Basic Creative Assets",
        "Campaign Monitoring",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Advanced Campaign Package",
      price: "",
      features: [
        "Multi-Channel Strategy",
        "Video and Graphic Production",
        "Paid Advertising Management",
        "Detailed Performance Reports",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Premium Brand Awareness Suite",
      price: "",
      features: [
        "Full Campaign Management",
        "Influencer Partnerships",
        "Event Marketing Support",
        "Comprehensive Analytics & Optimization",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: BrandingMain_CoverImage,
  title: "Brand Awareness Campaign Services",
  subtitle:
    "Increase your brands visibility and customer engagement with expertly crafted awareness campaigns.",
  coverImage: {
    src: BrandingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "What channels do you use for brand awareness campaigns?",
      answer:
        "We leverage social media, digital ads, influencer marketing, PR, events, and traditional advertising.",
    },
    {
      question: "How do you measure brand awareness success?",
      answer:
        "Through metrics like reach, impressions, engagement rates, website traffic, and brand recall surveys.",
    },
    {
      question: "Can you handle campaigns for new and existing brands?",
      answer:
        "Yes, we design tailored strategies whether youre launching a new brand or growing an established one.",
    },
    {
      question: "Do you provide creative content for campaigns?",
      answer:
        "Absolutely. We create videos, graphics, copy, and other assets aligned with your brand identity.",
    },
    {
      question: "How quickly can a campaign be launched?",
      answer:
        "Depending on the scope, campaigns can be planned and launched within 2-4 weeks.",
    },
  ],
};

export const RebrandingServicesPageDetails = {
  SeoName: {
    seotitle: "RebrandingServicesPageDetailsseo",
  },
  section2: {
    tagline: "Refresh and Reinvent Your Brand",
    heading:
      "Professional DefaultIcon Services to Elevate Your Business Identity",
    description:
      "Cyber Space Digital helps businesses successfully navigate the DefaultIcon process to stay relevant, attract new customers, and reflect evolving company values.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Brand Audit & Analysis",
      description:
        "Comprehensive evaluation of your current brand to identify strengths, weaknesses, and growth opportunities.",
      details: [
        "Market positioning review",
        "Competitor benchmarking",
        "Customer perception analysis",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Visual Identity Redesign",
      description:
        "Update your logo, color palette, typography, and other visual elements to reflect your new brand direction.",
      details: [
        "Logo redesign and refinement",
        "Brand color and font selection",
        "Collateral design updates",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Messaging & Tone Refinement",
      description:
        "Craft clear, consistent messaging that resonates with your target audience and supports your DefaultIcon goals.",
      details: [
        "Tagline and slogan development",
        "Brand voice guidelines",
        "Content strategy alignment",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "DefaultIcon Strategy & Rollout",
      description:
        "Plan and execute a seamless transition across all platforms and touchpoints to ensure brand consistency.",
      details: [
        "Internal team alignment and training",
        "Customer communication planning",
        "Marketing campaign development",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Post-DefaultIcon Support",
      description:
        "Ongoing support to monitor brand performance and make adjustments as needed.",
      details: [
        "Brand tracking and feedback analysis",
        "Performance reporting",
        "Continuous brand optimization",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic DefaultIcon Package",
      price: "",
      features: [
        "Brand Audit",
        "Logo Refresh",
        "Messaging Update",
        "Rollout Planning",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Comprehensive DefaultIcon Package",
      price: "",
      features: [
        "Full Visual Identity Redesign",
        "Messaging & Tone Refinement",
        "Marketing Rollout",
        "Post-Launch Support",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Enterprise DefaultIcon Suite",
      price: "",
      features: [
        "Complete Brand Transformation",
        "Custom Strategy & Execution",
        "Team Training & Support",
        "Ongoing Brand Performance Monitoring",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: BrandingMain_CoverImage,
  title: "DefaultIcon Services",
  subtitle:
    "Transform your brand identity to better connect with your audience and reflect your companys evolution.",
  coverImage: {
    src: BrandingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "What is included in a DefaultIcon service?",
      answer:
        "It includes brand audit, visual redesign, messaging updates, strategy planning, rollout execution, and ongoing support.",
    },
    {
      question: "How long does a DefaultIcon process take?",
      answer:
        "Typically, it takes 6 to 12 weeks depending on the scope and complexity of the project.",
    },
    {
      question: "Will DefaultIcon affect my existing customers?",
      answer:
        "When done well, DefaultIcon strengthens customer loyalty and attracts new audiences without losing existing ones.",
    },
    {
      question: "Can you help with digital and offline brand updates?",
      answer:
        "Yes, we ensure consistent DefaultIcon across websites, social media, print materials, and other touchpoints.",
    },
    {
      question: "Do you offer support after the DefaultIcon launch?",
      answer:
        "Absolutely, we provide ongoing brand performance monitoring and adjustment recommendations.",
    },
  ],
};

export const BrandResearchAndAnalysisPageDetails = {
  SeoName: {
    seotitle: "BrandResearchAndAnalysisPageDetailsseo",
  },
  section2: {
    tagline: "Understand Your Brands True Potential",
    heading: "In-Depth Brand Research & Analysis Services",
    description:
      "Cyber Space Digital provides comprehensive brand research and analysis to uncover insights that guide effective branding strategies and business growth.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Market Research",
      description:
        "Gather detailed data on your industry, competitors, and target audience to inform strategic decisions.",
      details: [
        "Competitive landscape assessment",
        "Customer demographics and psychographics",
        "Trend analysis and market opportunities",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Brand Perception Analysis",
      description:
        "Evaluate how your brand is currently perceived by customers, stakeholders, and the market.",
      details: [
        "Surveys and feedback collection",
        "Social media sentiment analysis",
        "Customer experience reviews",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Brand Equity Measurement",
      description:
        "Assess the value and strength of your brand in the marketplace to understand its impact on business performance.",
      details: [
        "Brand awareness tracking",
        "Brand loyalty and engagement metrics",
        "Financial value estimation",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "SWOT Analysis",
      description:
        "Identify your brands strengths, weaknesses, opportunities, and threats to build a robust branding strategy.",
      details: [
        "Internal and external factor assessment",
        "Strategic planning insights",
        "Risk mitigation recommendations",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Customer Journey Mapping",
      description:
        "Visualize the complete customer experience with your brand to identify pain points and opportunities for improvement.",
      details: [
        "Touchpoint analysis",
        "Experience optimization strategies",
        "Personalization opportunities",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Research Package",
      price: "",
      features: ["Market Overview", "Brand Perception Survey", "SWOT Summary"],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Advanced Analysis Package",
      price: "",
      features: [
        "Comprehensive Market & Competitor Research",
        "Brand Equity Measurement",
        "Customer Journey Mapping",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Enterprise Insight Suite",
      price: "",
      features: [
        "Full Research & Analysis Portfolio",
        "Custom Reports & Strategic Recommendations",
        "Ongoing Brand Monitoring",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: BrandingMain_CoverImage,
  title: "Brand Research and Analysis",
  subtitle:
    "Unlock valuable insights about your brand, customers, and market to drive smarter business decisions.",
  coverImage: {
    src: BrandingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "Why is brand research important?",
      answer:
        "It provides insights into market trends, customer perceptions, and competitive positioning to guide effective branding strategies.",
    },
    {
      question: "How do you conduct brand perception analysis?",
      answer:
        "We use surveys, social media monitoring, and customer feedback to understand how your brand is viewed.",
    },
    {
      question: "What is brand equity and why measure it?",
      answer:
        "Brand equity is the value your brand adds to your products or services. Measuring it helps assess brand strength and financial impact.",
    },
    {
      question: "Can brand research improve marketing efforts?",
      answer:
        "Absolutely. It helps tailor messaging, identify opportunities, and optimize customer engagement for better results.",
    },
    {
      question: "Do you provide customized research reports?",
      answer:
        "Yes, we deliver detailed, tailored reports that meet your specific business goals and branding needs.",
    },
  ],
};

export const BrandTrackingAndPerformanceEvaluationPageDetails = {
  SeoName: {
    seotitle: "BrandTrackingAndPerformanceEvaluationPageDetailsseo",
  },
  section2: {
    tagline: "Monitor Your Brands Impact Continuously",
    heading: "Comprehensive Brand Tracking & Performance Evaluation",
    description:
      "Cyber Space Digital helps you measure and evaluate your brands performance over time to ensure sustained growth and alignment with business goals.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Brand Awareness Tracking",
      description:
        "Track how widely your brand is recognized across different markets and customer segments.",
      details: [
        "Surveys and brand recall studies",
        "Digital analytics and social listening",
        "Media coverage and share of voice analysis",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Brand Equity Monitoring",
      description:
        "Measure ongoing changes in brand equity to understand your brands value trajectory.",
      details: [
        "Customer loyalty and advocacy metrics",
        "Engagement and sentiment analysis",
        "Competitive benchmarking",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Performance KPIs & Metrics",
      description:
        "Define and track key performance indicators tailored to your brand strategy and business objectives.",
      details: [
        "Sales impact analysis",
        "Market share tracking",
        "Customer satisfaction and NPS scores",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Campaign Effectiveness Evaluation",
      description:
        "Assess the success of branding campaigns through data-driven analysis.",
      details: [
        "ROI measurement",
        "Audience reach and engagement",
        "Conversion tracking",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Custom Reporting & Insights",
      description:
        "Receive regular, tailored reports that highlight insights, trends, and actionable recommendations.",
      details: [
        "Dashboard setup and maintenance",
        "Monthly and quarterly performance reviews",
        "Strategic adjustments and optimization",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Tracking Plan",
      price: "",
      features: [
        "Brand Awareness Reports",
        "Basic Equity Monitoring",
        "Quarterly Performance Reviews",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Advanced Evaluation Plan",
      price: "",
      features: [
        "Full KPI Tracking",
        "Campaign Effectiveness Analysis",
        "Monthly Custom Reports",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Enterprise Monitoring Suite",
      price: "",
      features: [
        "Comprehensive Brand & Performance Monitoring",
        "Real-time Dashboard Access",
        "Dedicated Strategic Consultation",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  coverimage: BrandingMain_CoverImage,
  title: "Brand Tracking and Performance Evaluation",
  subtitle:
    "Ensure your brand stays strong and relevant with ongoing monitoring, analysis, and strategic adjustments.",
  coverImage: {
    src: BrandingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  faqs: [
    {
      question: "Why is brand tracking important?",
      answer:
        "Continuous tracking helps identify changes in brand perception and performance to respond proactively.",
    },
    {
      question: "How often do you provide performance reports?",
      answer:
        "We offer monthly and quarterly reports tailored to your needs and strategic goals.",
    },
    {
      question: "Can you help measure the success of branding campaigns?",
      answer:
        "Yes. We evaluate campaigns through ROI analysis, engagement metrics, and conversion tracking.",
    },
    {
      question: "What KPIs do you track for brand performance?",
      answer:
        "We track awareness, equity, customer satisfaction, market share, and sales impact among others.",
    },
    {
      question: "Do you offer customized dashboards for real-time monitoring?",
      answer:
        "Yes. We can set up dashboards that provide live insights and easy access to your brands health data.",
    },
  ],
};



